// Event Bus Global Event Types
export var EventTypes;
(function (EventTypes) {
    // Scheduled Events
    EventTypes["ScheduledEvent"] = "Scheduled Event";
    // CDP Events
    EventTypes["CDPIdentify"] = "CDP Identify";
    EventTypes["CDPGroup"] = "CDP Group";
    EventTypes["CDPTrack"] = "CDP Track";
    // Billing
    /*
      Global Billing Settings
    */
    EventTypes["BillingCompanyNameEdited"] = "Billing Company Name Edited";
    EventTypes["BillingAddressEdited"] = "Billing Address Edited";
    EventTypes["BillingContactEdited"] = "Billing Contact Edited";
    EventTypes["BillingDateEdited"] = "Billing Date Edited";
    /*
      All the events below are being used by Flowsite as of writing this comment.
    */
    EventTypes["TrialEndDateEdited"] = "Trial End Date Edited";
    EventTypes["PlanTypeEdited"] = "Plan Type Edited";
    EventTypes["SubscriptionStatusEdited"] = "Subscription Status Edited";
    EventTypes["InitialSubscriptionDateEdited"] = "Initial Subscription Date Edited";
    EventTypes["SubscriptionTermEdited"] = "Subscription Term Edited";
    EventTypes["BillingCycleEdited"] = "Billing Cycle Edited";
    /*
      And below are used by both Flowsite and the Global Account Billing Service
    */
    EventTypes["PaymentTermDayEdited"] = "Payment Term Day Edited";
    EventTypes["PaymentTermContextEdited"] = "Payment Term Context Edited";
    EventTypes["PaymentMethodEdited"] = "Payment Method Edited";
    EventTypes["CurrencyEdited"] = "Currency Edited";
    // Dashpivot Billing
    /*
      Dashpivot has its own billing events enum defined in its own shared-lib
      but the values do not conform to the new global billing events so we have
      a new definition here owned by the global-shared lib to be used by the
      Global Account Billing Service.
    */
    EventTypes["DashpivotTrialEndDateEdited"] = "Dashpivot Trial End Date Edited";
    EventTypes["DashpivotPlanTypeEdited"] = "Dashpivot Plan Type Edited";
    EventTypes["DashpivotSubscriptionStatusEdited"] = "Dashpivot Subscription Status Edited";
    EventTypes["DashpivotInitialSubscriptionDateEdited"] = "Dashpivot Initial Subscription Date Edited";
    EventTypes["DashpivotSubscriptionTermEdited"] = "Dashpivot Subscription Term Edited";
    EventTypes["DashpivotBillingCycleEdited"] = "Dashpivot Billing Cycle Edited";
    EventTypes["DashpivotContributorUsersPaidEdited"] = "Dashpivot Contributor Users Paid Edited";
    EventTypes["SitematePaidUsersPaidEdited"] = "Sitemate Paid Users Paid Edited";
    EventTypes["DashpivotLegacyPlanRestrictionsEdited"] = "Dashpivot Legacy Plan Restrictions Edited";
    // Flowsite Billing
    /*
      Flowsite has its own billing events enum defined in this same file
      but the values do not conform to the new global billing events so we have
      a new definition here to be used by Global Account Billing Service.
    */
    EventTypes["FlowsiteTrialEndDateEdited"] = "Flowsite Trial End Date Edited";
    EventTypes["FlowsitePlanTypeEdited"] = "Flowsite Plan Type Edited";
    EventTypes["FlowsiteSubscriptionStatusEdited"] = "Flowsite Subscription Status Edited";
    EventTypes["FlowsiteInitialSubscriptionDateEdited"] = "Flowsite Initial Subscription Date Edited";
    EventTypes["FlowsiteSubscriptionTermEdited"] = "Flowsite Subscription Term Edited";
    EventTypes["FlowsiteBillingCycleEdited"] = "Flowsite Billing Cycle Edited";
    // Sitemate Start
    EventTypes["IncorrectPasswordLockoutActivated"] = "Incorrect Password Lockout Activated";
    // Account
    EventTypes["SitemateStartAccountCreated"] = "Sitemate Start Account Created";
    EventTypes["SitemateStartAccountEdited"] = "Sitemate Start Account Edited";
    EventTypes["SitemateStartAccountDeleted"] = "Sitemate Start Account Deleted";
    // Account Settings
    EventTypes["AccountTypeEdited"] = "Account Type Edited";
    EventTypes["AutomatedBillingEdited"] = "Automated Billing Edited";
    EventTypes["SSOEnabledEdited"] = "SSO Enabled Edited";
    // Workspace
    EventTypes["WorkspaceCreated"] = "Workspace Created";
    EventTypes["WorkspaceEdited"] = "Workspace Edited";
    EventTypes["WorkspaceDeleted"] = "Workspace Deleted";
    EventTypes["UserInvited"] = "User Invited";
    EventTypes["UserRemoved"] = "User Removed";
})(EventTypes || (EventTypes = {}));
// Customer Data Platform (Segment) Event type
export var CDPEventTypes;
(function (CDPEventTypes) {
    CDPEventTypes["Identify"] = "identify";
    CDPEventTypes["Group"] = "group";
    CDPEventTypes["Track"] = "track";
    CDPEventTypes["Page"] = "page";
    CDPEventTypes["Alias"] = "alias";
    CDPEventTypes["Screen"] = "screen";
})(CDPEventTypes || (CDPEventTypes = {}));
